<!--
  Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<br/>
<h1 class="page-header">Restricted Program Access Management</h1>
@if (canViewPage()) {
  <div>
    <table style="width: 100%;">
      <tr>
        <td>
          <p-confirmDialog key="updateUserConfirmation"></p-confirmDialog>
        </td>
        <td>
          <div class="buttons pull-right">
            <p-button label="Save All Changes" (click)="saveRestrictedPrograms()" icon="pi pi-save"
              [disabled]="!canSaveAllChanges()"
            [loading]="!!(saving || exporting || resetting)" class="gm-btn-primary mr-2"></p-button>
            <p-button icon="pi pi-download" (onClick)="exportReport()"
            label="Download Report" class="gm-btn-primary mr-2"></p-button>
            <p-button label="Reset Changes" (click)="resetChanges()"
              [loading]="!!(saving || exporting || resetting)"
            severity="warn" icon="pi pi-replay"></p-button>
          </div>
        </td>
      </tr>
    </table>
    <ag-grid-angular style="width: 100%; height: 80vh;" class="ag-theme-balham"
      [undoRedoCellEditing]="true" [enableCellTextSelection]="true"
      (cellEditingStopped)="cellEditingStopped($event)"
      [undoRedoCellEditingLimit]="50" [columnDefs]="cols" [rowData]="restrictedPrograms"
      [defaultColDef]="defaultColDef" [autoSizeStrategy]="autoSizeStrategy"
      (gridReady)="onGridReady($event)" [rowHeight]="60" [paginationPageSize]="20"
    [pagination]="true" [rowClassRules]="rowClassRules"></ag-grid-angular>
    <p-dialog header="Users With Access" [visible]="isModalVisible()" (visibleChange)="onDialogVisibilityChange($event)"
      [modal]="true" [style]="{width: '50vw'}">
      <p-confirmDialog key="deleteRowConfirmation"></p-confirmDialog>
        <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-balham"
          [undoRedoCellEditing]="true" [enableCellTextSelection]="true"
          (cellValueChanged)="modalDataChanged = true;"
          [undoRedoCellEditingLimit]="50" [columnDefs]="modalColumnDefs" [rowData]="modalRowData"
          [defaultColDef]="defaultColDef"
          (gridReady)="onModalGridReady($event)" [rowHeight]="60" [paginationPageSize]="20"
        [pagination]="true" [rowClassRules]="rowClassRules"></ag-grid-angular>
      <ng-template pTemplate="footer">
        <div class="buttons">
          <app-auto-search class="mr-2" (userSelected)="modalUserSelected($event);"
          [showMeButton]="true"></app-auto-search>
          <p-button label="Add User" (click)="addUserInModal()" icon="pi pi-plus"
          [disabled]="!canAddUserInModal()" class="gm-btn-primary mr-2"></p-button>
          <button pButton type="button" (click)="onDialogVisibilityChange(false)"><i class="pi pi-times" pButtonIcon></i><span pButtonLabel>Close</span></button>
        </div>
      </ng-template>
    </p-dialog>
  </div>
}

